import { ExpertRewardsConfiguration } from "@arbolus-technologies/models/common";

export const SET_REWARDS_CONFIGURATION = "CACHE_SET_REWARDS_CONFIGURATION";

export interface SetRewardsConfigurationAction {
  type: typeof SET_REWARDS_CONFIGURATION;
  payload: {
    rewardsConfiguration: ExpertRewardsConfiguration;
  };
}
